import { Avatar, Badge, Box, Button, Typography } from "@mui/material";
import { ROUTES } from "../../../constants/routes";
import { stringAvatar } from "../../../utils/avatar.util";
import moment from "moment";
import { getAuthUserId } from "../../../utils/auth.util";
import { useAppDispatch } from "../../../store/appHooks";
import { setConversation } from "../../../slices/messagesReducer";
import { useNavigate } from "react-router-dom";
import { formatMessageTime } from "utils/messages.util";

const ChatRoomItem = ({
  c,
  convId,
  getDisplayName,
}: {
  c: any;
  convId: string;
  getDisplayName: any;
}) => {
  const navigate = useNavigate();
  const loggedInAuthId = getAuthUserId();
  const dispatch = useAppDispatch();

  const participantId =
    c?.participants?.filter((c: string) => c !== loggedInAuthId)?.[0] ?? 0;

  const getAvatar = (cData: any) => {
    if (cData?.isNew && cData?.img) {
      return <Avatar src={c?.img} style={{ height: "48px", width: "48px" }} />;
    }
    if (cData?.isNew && !cData?.img) {
      return (
        <Avatar
          {...stringAvatar(getDisplayName(c))}
          style={{ height: "48px", width: "48px" }}
        />
      );
    }
    if (c?.[`profile_${participantId}`]) {
      return (
        <Avatar
          src={c?.[`profile_${participantId}`]}
          style={{ height: "48px", width: "48px" }}
        />
      );
    }

    return (
      <Avatar
        {...stringAvatar(getDisplayName(c))}
        style={{ height: "48px", width: "48px" }}
      />
    );
  };
  return (
    <Box
      component={Button}
      sx={{ padding: 0 }}
      fullWidth
      onClick={() => {
        navigate(ROUTES.MESSAGES.replace(":id", c.id));
        dispatch(setConversation(c));
      }}
    >
      <Box
        display="flex"
        justifyContent="space-between"
        width="100%"
        alignItems="center"
      >
        <Box
          display="flex"
          gap="5px"
          alignItems="center"
          width="100%"
          sx={{ minHeight: "80px" }}
        >
          {getAvatar(c)}

          <Box
            display="flex"
            flexDirection="column"
            justifyContent="space-between"
            width={"100%"}
            sx={{
              borderBottom: convId === c.id ? "" : "1px solid #E2E2E2",
              py: "20px",
              pl: "10px",
              pr: "20px",
            }}
          >
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
            >
              <Typography
                sx={{
                  fontWeight: 500,
                  fontSize: "15px",
                  lineHeight: "18px",
                  color: "#323232",
                  textAlign: "justify",
                  width: "200px",

                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  WebkitLineClamp: "2",
                  WebkitBoxOrient: "vertical",
                  display: "-webkit-box",
                }}
              >
                {getDisplayName(c)}
              </Typography>

              <Typography
                sx={{
                  fontWeight: 400,
                  fontSize: "13px",
                  lineHeight: "16px",
                  color: "#A2A2A2",
                }}
              >
                {c?.lastMessagedAt
                  ? formatMessageTime(c?.lastMessagedAt * 1000)
                  : ""}
              </Typography>
            </Box>

            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              minHeight="21px"
              mt="5px"
            >
              {c?.[`typingStatus${participantId}`] === true ? (
                <Typography
                  sx={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    display: "-webkit-box",
                    WebkitLineClamp: "1",
                    WebkitBoxOrient: "vertical",

                    fontWeight: 400,
                    fontSize: "14px",
                    lineHeight: "16px",
                    color: "#4EA643",
                  }}
                >
                  Typing...
                </Typography>
              ) : (
                <Typography
                  sx={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    display: "-webkit-box",
                    WebkitLineClamp: "1",
                    WebkitBoxOrient: "vertical",

                    fontWeight: 400,
                    fontSize: "14px",
                    lineHeight: "17px",
                    color: "#A2A2A2",
                  }}
                >
                  {c?.lastMessage}
                </Typography>
              )}
              {c?.messagedBy !== loggedInAuthId && c?.lastMessageCount > 0 && (
                <Box
                  sx={{
                    height: "8px",
                    width: "8px",
                    borderRadius: "50%",
                    background: "#6E8C20",
                  }}
                />
              )}
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default ChatRoomItem;
